import { render, staticRenderFns } from "./ProductDesignFormBotton.vue?vue&type=template&id=90217930&"
import script from "./ProductDesignFormBotton.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormBotton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports